export const Overline = ({ children }) => (
  <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.45em] text-[#06B6D4]">{children}</p>
);

export default Overline;
